import { ReqType } from '../types'

class ApiRequest implements ReqType {
	method: ReqType['method']
	uri: ReqType['uri']
	body: ReqType['body']
	query: ReqType['query']
	headers: ReqType['headers']
	customHeaders: ReqType['customHeaders']
	accessToken: ReqType['accessToken']
	isRequiredToken: ReqType['isRequiredToken']
	baseURL: ReqType['baseURL']
	isRefresh: ReqType['isRefresh']

	constructor({
		method = '',
		uri = '',
		body = {},
		query = {},
		headers = {},
		customHeaders = {},
		accessToken = '',
		isRequiredToken = true,
		isRefresh = true,
		baseURL = '',
	} = {}) {
		const paramMethod: ReqType['method'] = ['get', 'post', 'put', 'delete'].includes(
			method,
		)
			? (method as ReqType['method'])
			: 'get'

		this.method = paramMethod
		this.uri = uri
		this.body = body
		this.query = query
		this.headers = headers
		this.customHeaders = customHeaders
		this.accessToken = accessToken
		this.isRequiredToken = isRequiredToken
		this.isRefresh = isRefresh
		this.baseURL = baseURL
	}
}

export { ApiRequest }
